import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import PostInfo from 'modules/post/postinfo.component';
import ButtonContainer from 'modules/post/mobile/postButtons.container';
import { View } from 'modules/styled';
import Commentary from './commentary.component';

Post.propTypes = {
  link: PropTypes.object,
  post: PropTypes.object,
  commentary: PropTypes.array,
  singlePost: PropTypes.bool,
  hideDivider: PropTypes.bool,
  preview: PropTypes.bool,
  noLink: PropTypes.bool,
  focusInput: PropTypes.func,
  avatarText: PropTypes.func,
};

function Post(props) {
  const {
    link,
    commentary,
    singlePost,
    hideDivider,
    preview,
    noLink,
    post,
    focusInput,
    avatarText,
  } = props;
  const separator = <View sx={{ pt: 4, bg: 'rgba(0,0,0,.03)' }} />;
  const blocked = <View style={{ height: StyleSheet.hairlineWidth }} />;

  if (!post || !post._id) return blocked;

  const isLinkPost = link && (link.url || link.image);
  const renderComment = commentary && commentary.length;

  const commentaryEl = renderComment ? (
    <Commentary
      isReply
      isLinkPost={isLinkPost}
      preview={preview}
      post={post}
      link={link}
      singlePost={singlePost}
      commentary={commentary || [post]}
    />
  ) : null;

  const postEl = isLinkPost ? (
    <View sx={{ mt: preview ? 4 : 0 }}>
      <PostInfo
        key={link._id}
        post={post}
        link={link}
        singlePost={singlePost}
        preview={preview}
        noLink={noLink}
      />
      {!preview && (
        <View sx={{ m: 2 }}>
          <ButtonContainer
            focusInput={focusInput}
            horizontal
            post={post}
            singlePost={singlePost}
            link={link}
          />
        </View>
      )}
    </View>
  ) : (
    <Commentary
      preview={preview}
      post={post}
      link={link}
      singlePost={singlePost}
      commentary={[post]}
      focusInput={focusInput}
      avatarText={avatarText}
    />
  );

  return (
    <View sx={{ overflow: 'hidden' }}>
      <View>
        {postEl}
        {commentaryEl || (preview && isLinkPost ? <View sx={{ mt: 2 }} /> : null)}
      </View>
      {!singlePost && !hideDivider ? separator : null}
    </View>
  );
}

export default memo(Post);
